// 商品详情页
import * as React from "react"
import * as ReactDOM from "react-dom"
import * as DPlayer from "../../../libs/DPlayer.min"

import "../../../components/common"
import "../../../components/shop/common"
import Toast from "../../../components/popup/toast"
import config from "../../../utils/config"
import request from "../../../utils/request"
import * as utils from "../../../utils/utils"
import TakePhone from "../../../components/shop/take-phone"
import Language from "../../../components/Header/language"

export default class Offer extends React.Component<any, any> {
  private toastTimer: any
  private integralTimer: any
  private demoInstance: any

  constructor(props: any) {
    super(props)
    this.state = {
      windowWidth: window.innerWidth,
      id: utils.GetQueryString("id"), // 商品id
      modelNum: 1, // 数量
      pageInfo: {
        img: [],
        is_collect: 0,
        msds: {},
        physical: [],
        sku: [
          {
            price: [],
          },
        ],
        tds: {},
      }, // 页面数据
      skuPriceIndex: 0, // 第几个sku价格内容
      storeInfo: {
        tag: [],
        tags_img: [],
      }, // 店铺信息
      tabIndex: 0, // 下部分内容tab索引
      toastText: "", // 提示文本
      toastVisible: false, // 提示框可视化
      visiblePanel: false, // 选择可视化
      visibleScrollToTop: false, // 滚动回头部图标可视化
      member_type: "",
      cardInfo: "", // 卡片信息
      cardShow: false, // 卡片显示控制
      applet: utils.GetQueryString("applet") || "0", // 是否从小程序访问 0 不是 1 是
      askingPriceVisible: false, // 询价提示
      soldout: false, // 商品是否售罄

      showRedDot: false, // 在线联系红点

      // productParametersVisible: false, // 产品参数
      goodsList: {
        tab: [],
        goods: [],
      }, // 推荐商品列表
      videoVisible: false, // 显示视频
      languageEnUrl: window.location.origin.replace(".cn", ".en") + "/m/",
    }
  }
  public componentDidMount() {
    // 如果没有对应产品，跳转到商铺首页
    if (this.state.id === "0") {
      window.location.href = "/m/"
      return
    }
    this.getData()
    this._getCardInfo()
    this.getSeoData()
    this.getRecommendGoods()

    this.integralTimer = (window as any).integral.delay(
      {
        env: config.ENV === "production" ? "pro" : "dev",
        code: "00_04_00_004",
        entityId: this.state.id,
        entityType: "ws_goods",
        system: 3,
      },
      15000
    )

    this.demoInstance = new (window as any).GetDemo(
      config.ENV === "production" ? "production" : "dev"
    )
  }
  public componentWillUnmount() {
    if (this.integralTimer) {
      clearTimeout(this.integralTimer)
    }
    this.demoInstance.destroy()
    this.demoInstance = null
  }
  public render() {
    const that = this
    const state = this.state
    return (
      <div>
        {(state.cardShow ||
          state.productParametersVisible ||
          state.downloadPDFVisible ||
          state.visiblePanel ||
          state.attentShow) && <div className="touming"></div>}
        {state.cardShow && (
          <div className="shopCard" style={{ display: "block" }}>
            <div className="shop-info">
              <h2>{this.state.cardInfo.companyName}</h2>
              <p>
                <img src={this.state.cardInfo.seller_grade} />
                <span>
                  企业类型：{this.state.cardInfo.companyCategoryValue}
                </span>
              </p>
            </div>
            <ul>
              <li>
                <b>联系人：</b>
                <span>{this.state.cardInfo.contact}</span>
              </li>
              <li>
                <b>职务：</b>
                <span>{this.state.cardInfo.position}</span>
              </li>
              <li>
                <b>公司电话：</b>
                <span className="tel" onClick={this.takePhoneHandle}></span>
              </li>
              <li>
                <b>公司地址：</b>
                <span>{this.state.cardInfo.address}</span>
              </li>
            </ul>
            <span
              className="closeBtn"
              onClick={() => this._showCard(false)}
            ></span>
          </div>
        )}
        {state.attentShow && (
          <div className="success shop_collect" style={{ display: "block" }}>
            <p className="collect-tips">
              <img
                className="tips-img"
                src="https://style.ibuychem.com/wiseshop/pc/images/right.png"
              />
              <span>
                {state.pageInfo.is_collect === 0 ? "取消" : "关注"}成功
              </span>
            </p>
            <p className="display-word">
              您已成功{state.pageInfo.is_collect === 0 ? "取消" : ""}
              关注该店铺！
            </p>
            <span
              className="close"
              onClick={() => this.toggleAttention(false)}
            ></span>
          </div>
        )}
        <div className="selects-wrapper">
          <Language
            className="inside"
            lan="1"
            url={
              this.state.languageEnUrl +
              "offer?id=" +
              this.state.pageInfo.push_goods_id
            }
          />
        </div>
        <div className="searchfl">
          <div className="searchfl-back">
            <span>
              <img
                src="https://fanhuahuaxue.cn.ibuychem.com/static/media/img_w012.3f76fc8d.png"
                onClick={() => this.backAction()}
              />
            </span>
          </div>
          <div className="searchfl-ss" style={{ width: "79%" }}>
            <img src={require("../../../assets/images/msp_15.png")} />
            <input
              type="text"
              name=""
              placeholder="搜索"
              onKeyDown={() => this._search(event)}
            />
          </div>
          <div className="searchfl-gwc">
            <a href="/m/cart/">
              <img src={require("../../../assets/images/msp_17.png")} />
            </a>
          </div>
        </div>
        <div className="cpDetail">
          <ul className="imgscroll">
            {state.pageInfo.goods_video_url && (
              // <li
              //   style={{
              //     width: !state.pageInfo.img.length ? "97%" : "initial",
              //   }}
              //   onClick={() => this.openVideo(true)}
              // >
              //   <div className="goods-video">
              //     <span></span>
              //     <img
              //       src={
              //         state.pageInfo.video_img_url ||
              //         state.pageInfo.video_img_auto_url
              //       }
              //     />
              //   </div>
              // </li>
              <li
                style={{
                  width: !state.pageInfo.img.length ? "97%" : "initial",
                }}
              >
                <div className="goods-video">
                  <video
                    playsinline={true}
                    x5-playsinline={true}
                    webkit-playsinline={true}
                    data-index="-1"
                    crossOrigin="anonymous"
                    src={this.state.pageInfo.goods_video_url}
                    poster={
                      this.state.pageInfo.video_img_url ||
                      this.state.pageInfo.video_img_auto_url
                    }
                    autoPlay={true}
                    controls={true}
                  ></video>
                </div>
              </li>
            )}
            {state.pageInfo.img.map((v: any, k: number) => {
              return (
                <li
                  key={`goodsBanner${k}`}
                  style={{
                    width:
                      state.pageInfo.img.length === 1 &&
                      !state.pageInfo.goods_video_url
                        ? "97%"
                        : "initial",
                  }}
                >
                  <img src={v.img_src} alt={state.pageInfo.goods_name} />
                </li>
              )
            })}
            <li style={{ width: "1px", background: "none" }}></li>
          </ul>
          <div className="xq">
            <p className="title">
              {state.pageInfo.is_treasure === "1" && (
                <img
                  className="goods-details-topicon"
                  src={require("../../../assets/images/tz_36.png")}
                  alt=""
                />
              )}
              {state.pageInfo.goods_name}
            </p>
            <div>
              <div className="flex-wrap">
                {state.pageInfo.price_type === "4" && (
                  <div className="flex-wrap flex">
                    <div className="flex sku-item">
                      <span className="co-red fs-20">
                        {state.pageInfo.symbol}
                        {state.pageInfo.proposed_price}
                      </span>
                      {state.pageInfo.proposed_price !== "代理招商/项目洽淡" &&
                        state.pageInfo.proposed_price !== "询价" && (
                          <span className="goods-detail-unit">
                            / {state.pageInfo.unit_name}
                          </span>
                        )}
                      {state.pageInfo.proposed_price !== "代理招商/项目洽淡" &&
                        state.pageInfo.proposed_price !== "询价" && (
                          <img
                            src={require("../../../assets/images/wen.png")}
                            className="icon-help"
                            onClick={() => this.setAskingPriceTips(true)}
                          />
                        )}
                      {state.askingPriceVisible && (
                        <div className="asking">
                          <div className="asking-price">
                            <div className="asking-price-text">
                              <img
                                src={require("../../../assets/images/msp_24.png")}
                              />
                              <p>
                                价格仅为商家提供的意见价，非真实的成交价。请通过“找我询价”，获得最新、最真实的成交价
                              </p>
                            </div>
                          </div>
                        </div>
                      )}
                      {state.askingPriceVisible && (
                        <div
                          className="asking-price-mask"
                          onClick={() => this.setAskingPriceTips(false)}
                        ></div>
                      )}
                    </div>
                  </div>
                )}
                {state.pageInfo.price_type === "2" && (
                  <div className="flex-wrap flex">
                    <div className="flex sku-item">
                      <span className="co-red fs-20">
                        <i>{state.pageInfo.symbol}</i>
                        {state.pageInfo.show_discount_price ||
                          state.pageInfo.show_origin_price}
                        <i className="small">/{state.pageInfo.unit_name}</i>
                      </span>
                    </div>
                  </div>
                )}
                {state.pageInfo.price_type === "1" &&
                  state.pageInfo.sku.map((v: any, k: number) => {
                    return (
                      <div className="flex-wrap flex" key={v.sku_id}>
                        {v.price.map((v1: any, k1: number) => {
                          return (
                            <span className="jtjg" key={v1.price_id}>
                              <span className="co-red fs-32">
                                <i>{state.pageInfo.symbol}</i>
                                {parseFloat(v1.discount_price)
                                  ? v1.discount_price
                                  : v1.origin_price}
                              </span>
                              <br />
                              {state.pageInfo.price_type === "1" &&
                              !state.soldout ? (
                                k1 === v.price.length - 1 ? (
                                  <span className="fs-14 ds">
                                    {" "}
                                    ≥ {v1.begin_num} {state.pageInfo.unit_name}
                                  </span>
                                ) : (
                                  <span className="fs-14 ds">
                                    {" "}
                                    {v1.begin_num} - {v1.end_num}{" "}
                                    {state.pageInfo.unit_name}{" "}
                                  </span>
                                )
                              ) : null}
                            </span>
                          )
                        })}
                      </div>
                    )
                  })}
              </div>
            </div>
            <ul className="baozheng" style={{ display: "none" }}>
              {state.storeInfo.tag.map((v: string, k: number) => {
                return (
                  <li key={v + k}>
                    <span>{v}</span>
                  </li>
                )
              })}
            </ul>
          </div>
          {state.pageInfo.apply_demo === 1 && (
            <div className="mfxy">
              <a href="javascript: void(0)" onClick={() => this.goToDemo()}>
                <div className="mfxytop">
                  <span>获取小样</span>
                  <em>
                    1款现样、随机发货
                    <img src={require("../../../assets/images/msp_22.png")} />
                  </em>
                </div>
                <div className="mfxybtm">
                  <i>免费试用</i>
                  <p>
                    通过商家审核后方可试用样品，且每个买家限购<em>1</em>次
                  </p>
                </div>
              </a>
            </div>
          )}

          <ul className="csxq">
            {state.pageInfo.price_type !== "4" && !state.soldout && (
              <li onClick={() => this.setPanelVisibleAction(true)}>
                <h4>规格</h4>
                <div className="csxqcon csxqchoose">
                  <span>选择规格</span>
                  <img src={require("../../../assets/images/msp_22.png")} />
                </div>
              </li>
            )}
            {!state.soldout && state.pageInfo.sku[0].warehouse !== "" && (
              <li>
                <h4>发货</h4>
                <div className="csxqcon">{state.pageInfo.sku[0].warehouse}</div>
              </li>
            )}
            {/* {state.pageInfo.physical && state.pageInfo.physical.length > 0 && (
              <li
                onClick={() =>
                  this.setStateItem("productParametersVisible", true)
                }
              >
                <h4>参数</h4>
                <div className="csxqcon csxqcs">
                  商品主要参数
                  <img src={require("../../../assets/images/msp_22.png")} />
                </div>
              </li>
            )} */}
            {(state.pageInfo.msds.name || state.pageInfo.tds.name) && (
              <li onClick={() => this.setStateItem("downloadPDFVisible", true)}>
                <h4>下载</h4>
                <div className="csxqcon csxqpdf">
                  产品TDS/MSDS
                  <img src={require("../../../assets/images/msp_22.png")} />
                </div>
              </li>
            )}
          </ul>
          {state.pageInfo.physical.length > 0 && (
            <div className="goodsdetail-physical">
              <table>
                <thead>
                  <tr>
                    <th style={{ width: "30%" }}>物性名称</th>
                    <th style={{ width: "35%" }}>物性值</th>
                    <th style={{ width: "35%" }}>备注(测试条件)</th>
                  </tr>
                </thead>
                <tbody>
                  {state.pageInfo.physical.map(function (v, k) {
                    return (
                      <tr key={v.physical_id}>
                        <td>{v.name}</td>
                        <td>
                          {v.numerical}{" "}
                          <span
                            dangerouslySetInnerHTML={{ __html: v.unit }}
                          ></span>
                        </td>
                        <td>{v.remark || "/"}</td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          )}
          <div className="store">
            <div className="store-top">
              <div className="shops">
                <div className="shop-head">
                  <img src={state.storeInfo.mobile_logo} />
                </div>
                <div className="shop-name">
                  <h2>{state.storeInfo.shop_name}</h2>
                  <p>
                    {state.storeInfo.shop_level_url && (
                      <b className="vip">
                        <img src={state.storeInfo.shop_level_url} />
                      </b>
                    )}
                    <span className="goods-detail-shop-level">
                      {state.storeInfo.member_type} {state.storeInfo.year}年
                    </span>
                    <span>
                      企业类型：{state.storeInfo.companyCategoryValue}
                    </span>
                  </p>
                </div>
                <a href={state.storeInfo.shop_domain_wap} className="sp-jd">
                  进店
                </a>
              </div>
              {this.showShopInfo()}
            </div>
            <div className="store-btm">
              <div id="focus" className="spfocus">
                <div className="bd swiper mySwiper">
                  <div className="swiper-wrapper">
                    {state.goodsList.tab.map(function (v: any) {
                      return that.renderGoodsItem(v)
                    })}
                    {state.goodsList.goods.map(function (v: any, k: number) {
                      return that.renderGoodsItem(v)
                    })}
                  </div>
                </div>
                <div className="swiper-pagination"></div>
              </div>
            </div>
          </div>

          <div className="newxq">
            <div className="newxq_title">—— 产品详情 ——</div>
            <div className="newxqcon">
              <div
                className="newxqcon-text"
                dangerouslySetInnerHTML={{ __html: state.pageInfo.goods_desc }}
              ></div>
            </div>
          </div>

          <div className="mzsm">
            <h6>内容声明</h6>
            <p>
              买化塑为第三方交易平台及互联网信息服务提供者，买化塑（含网站、客户端等）所展示的商品/服务的标题、价格、详情等信息内容系由商铺经营者发布，其真实性、准确性和合法性均由商铺经营者负责;
            </p>
            <p>
              买化塑提醒您购买商品/服务前注意谨慎核实，如您对商品/服务的标题、价格、详情等任何信息有任何疑问的，请在购买前与商铺经营者沟通确认;
            </p>
            <p>
              买化塑存在海量商铺，如您发现商铺内有任何违法/侵权信息，请立即向买化塑举报并提供有效线索。
            </p>
          </div>
        </div>
        <div className="newxq_title">—— 已经到底啦 ——</div>
        <p
          className={
            state.soldout ? "shopNavPadding disabled" : "shopNavPadding"
          }
        ></p>
        <div className={`choose ${state.visiblePanel ? "active" : ""}`}>
          <dl>
            <dt>
              {state.pageInfo.img[0] ? (
                <img
                  className="img-priview"
                  src={state.pageInfo.img[0].img_src}
                />
              ) : null}
            </dt>
            <dd>
              {!state.soldout &&
              state.pageInfo.sku[0] &&
              state.pageInfo.sku[0].price &&
              state.pageInfo.sku[0].price[state.skuPriceIndex] ? (
                <div className="jiage">
                  {" "}
                  <span>
                    {state.pageInfo.symbol}
                    {parseFloat(
                      state.pageInfo.sku[0].price[state.skuPriceIndex]
                        .discount_price
                    )
                      ? state.pageInfo.sku[0].price[state.skuPriceIndex]
                          .discount_price
                      : state.pageInfo.sku[0].price[state.skuPriceIndex]
                          .origin_price}
                    <i>/{state.pageInfo.unit_name}</i>
                  </span>
                  <b>
                    {state.pageInfo.price_type === "1"
                      ? state.pageInfo.sku[0].price[0].begin_num +
                        state.pageInfo.unit_name +
                        "起批"
                      : ""}
                  </b>
                </div>
              ) : null}
              <div className="title">{state.pageInfo.goods_name}</div>
            </dd>
          </dl>
          <div className="add">
            <span>购买数量</span>
            <div className="jia">
              <a
                href="javascript:void(0);"
                className="reduce reSty"
                onClick={() => this.reduceAction()}
              >
                -
              </a>
              <input
                type="number"
                value={state.modelNum}
                className="sum"
                onChange={(e) => this.modelChangeAction(e)}
                onBlur={(e) => this.modelBlurAction(e)}
              />
              <a
                href="javascript:void(0);"
                className="plus"
                onClick={() => this.plusAction()}
              >
                +
              </a>
            </div>
          </div>
          <button onClick={() => this.chooseConfirm()}>确 定</button>
          <span
            className="close"
            onClick={() => this.setPanelVisibleAction(false)}
          />
        </div>
        <div className={`shopNav ${state.soldout ? "sq" : ""}`}>
          <div className="shopNav-left">
            <ul>
              {state.applet !== "1" ? (
                <li>
                  <a href="/m/">
                    <i className="wp" />
                    <span>商铺</span>
                  </a>
                </li>
              ) : null}

              {/*<li><a href={`tel:${state.storeInfo.contact_tel}`}><i className="kf" /><span>客服</span></a></li>*/}
              <li onClick={() => this._showCard(true)}>
                <a href="javascript:;">
                  <i className="kf" />
                  <span>联系卖家</span>
                </a>
              </li>
              <li onClick={() => this.collectAction()}>
                <a href="javascript: void(0);">
                  <i
                    className={state.pageInfo.is_collect === 0 ? "wsc" : "ysc"}
                  />
                  <span>
                    {state.pageInfo.is_collect === 0 ? "关注" : "取消"}
                  </span>
                </a>
              </li>
            </ul>
          </div>
          {state.pageInfo.price_type === "4" ? (
            <div className="jiaru">
              <button
                className={state.soldout ? "xj disabled" : "xj"}
                onClick={() => this.askingPrice()}
              >
                找我询价
              </button>
            </div>
          ) : (
            <div className="jiaru">
              <button
                className={state.soldout ? "jr disabled" : "jr"}
                onClick={() => this.addCart()}
              >
                加入进货单
              </button>
              <button
                className={state.soldout ? "gm disabled" : "gm"}
                onClick={() => this.buyNow()}
              >
                立即购买
              </button>
            </div>
          )}
        </div>
        {state.soldout && <p className="spysq">商品已售罄</p>}
        {/* 在线联系 */}
        <div className="online-contact" onClick={() => this.goToConsult()}>
          <img
            className="online-icon"
            src={require("../../../assets/images/online1.png")}
            alt=""
          />
          {state.showRedDot && <div className="red-dot"></div>}
        </div>

        {/* {state.productParametersVisible && (
          <div className="cscon">
            <h3>产品参数</h3>
            <ul>
              {state.pageInfo.physical.map((v, k) => {
                return (
                  <li key={k}>
                    <h4>{v.name}</h4>
                    <div className="csxqcon">
                      {v.numerical}
                      {v.unit} {v.remark}
                    </div>
                  </li>
                )
              })}
            </ul>
            <span
              className="csclose"
              onClick={() =>
                this.setStateItem("productParametersVisible", false)
              }
            >
              关 闭
            </span>
          </div>
        )} */}
        {state.downloadPDFVisible && (
          <div className="pdfcon">
            <h3>下载产品TDS/MSDS</h3>
            <ul>
              {state.pageInfo.msds.name && (
                <li>
                  <a href={state.pageInfo.msds.url} download={true}>
                    <span>{state.pageInfo.msds.name}</span>
                    <i>立即下载</i>
                  </a>
                </li>
              )}
              {state.pageInfo.tds.name && (
                <li>
                  <a href={state.pageInfo.tds.url} download={true}>
                    <span>{state.pageInfo.tds.name}</span>
                    <i>立即下载</i>
                  </a>
                </li>
              )}
            </ul>
            <span
              className="pdfclose"
              onClick={() => this.setStateItem("downloadPDFVisible", false)}
            >
              关 闭
            </span>
          </div>
        )}

        {
          //   state.videoVisible && (
          //   <div className="video-player-panel">
          //     <span
          //       className="video-player-close"
          //       onClick={(e) => this.openVideo(false, e)}
          //     ></span>
          //     <div id="dplayer"></div>
          //     {state.pageInfo.price_type === "4" && (
          //       <h5>
          //         {state.pageInfo.symbol} {state.pageInfo.proposed_price} /
          //         {state.pageInfo.unit_name}
          //       </h5>
          //     )}
          //     {state.pageInfo.price_type !== "4" && (
          //       <h5>
          //         {state.pageInfo.sku.map((v: any, k: number) => {
          //           return v.price.map((v1: any, k1: number) => {
          //             return (
          //               <span key={k1}>
          //                 {state.pageInfo.symbol}
          //                 {parseFloat(v1.discount_price)
          //                   ? v1.discount_price
          //                   : v1.origin_price}
          //                 /{state.pageInfo.unit_name}
          //               </span>
          //             )
          //           })
          //         })}
          //       </h5>
          //     )}
          //     <p>{state.pageInfo.goods_name}</p>
          //   </div>
          // )
        }

        <Toast text={this.state.toastText} visible={this.state.toastVisible} />
        <TakePhone
          className="offer-take-phone"
          phone={this.state.cardInfo ? this.state.cardInfo.contact_tel : ""}
        />
      </div>
    )
  }

  private setStateItem(key: string, val: any) {
    this.setState({
      [key]: val,
    })
  }

  // 显示名片
  private _showCard(open: boolean) {
    this.setState({
      cardShow: open,
    })
  }

  // 获取名片信息
  private async _getCardInfo() {
    const path: any = (window as any).shopId
    const r = await request({
      data: {
        shopDomain: path,
      },
      method: "post",
      url: `${config.PHPAPI}api/wshop/shop/shop-card`,
    })

    if (r.error_code === 0) {
      this.setState({
        cardInfo: r.msg,
      })
    }
  }

  // 获取商品
  private async getRecommendGoods() {
    const r = await request({
      data: {
        typeId: 4,
        portType: 2,
        shopDomain: (window as any).shopId,
        pageSize: 9,
      },
      method: "post",
      url: `${config.PHPAPI}api/wshop/goods/tag-goods`,
    })

    if (r.error_code === 0) {
      this.setState(
        {
          goodsList: r.data,
        },
        () => {
          new (window as any).Swiper(".mySwiper", {
            autoplay: {
              disableOnInteraction: false,
            },
            slidesPerView: 3,
            spaceBetween: 10,
            slidesPerGroup: 3,
            loop: false,
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
          })
        }
      )
    }
  }

  private renderGoodsItem(v) {
    return (
      <div className="swiper-slide" key={v.goods_id}>
        <div className="tjcp">
          <a href={`/m/offer?id=${v.goods_id}`}>
            <img
              src={v.img_src}
              style={{
                height: (this.state.windowWidth * 0.94 * 0.96 - 20) / 3 + "px",
              }}
            />
            {v.price_type === "3" ? (
              <p>面议</p>
            ) : (
              <p>
                {v.symbol}
                {v.price}
              </p>
            )}
          </a>
        </div>
      </div>
    )
  }

  // 搜索
  private _search(e: any) {
    if (e.keyCode === 13) {
      const keyword = encodeURIComponent(e.srcElement.value)
      window.location.href =
        window.location.origin +
        "/m/offerlist?keyword=" +
        encodeURIComponent(keyword)
    }
  }

  /**
   * [设置面板可视化]
   * @param  visible [boolean] 显示&隐藏
   */
  private setPanelVisibleAction(visible: boolean) {
    this.setState({ visiblePanel: visible })
    if (visible) {
      document.body.className = "auto"
    } else {
      document.body.className = ""
    }
  }
  // 数量减去1
  private reduceAction() {
    let r: number = this.state.modelNum
    r = utils.cal(r, 1).plus
    // 如果是起批价
    if (this.state.pageInfo.price_type === "1") {
      // 最少必须为大于起批量
      const minNum = parseFloat(this.state.pageInfo.sku[0].price[0].begin_num)
      r = r < minNum ? minNum : r
    } else {
      r = r < 1 ? 1 : r
    }
    this.calcInfo(r)
    this.setState({ modelNum: r })
  }
  // 数量改变
  private modelChangeAction(e: any) {
    this.setState({ modelNum: e.target.value })
  }
  // 数量失焦校验
  private modelBlurAction(e: any) {
    if (e.target.value === "") {
      return this.setState({ modelNum: "" })
    }
    let r =
      this.state.pageInfo.price_type === "1"
        ? parseFloat(this.state.pageInfo.sku[0].price[0].begin_num)
        : 1
    if (!isNaN(e.target.value) && e.target.value > 0) {
      const maxNum = parseFloat(this.state.pageInfo.sku[0].stock)
      const targetNum = parseFloat(e.target.value)
      if (this.state.pageInfo.price_type === "1") {
        const minNum = parseFloat(this.state.pageInfo.sku[0].price[0].begin_num)
        if (targetNum < minNum) {
          r = minNum
        }
      } else {
        if (targetNum < 1) {
          r = 1
        }
      }
      if (targetNum > maxNum) {
        r = maxNum
      } else {
        r = targetNum
      }
    }
    this.calcInfo(r)
    this.setState({ modelNum: r })
  }
  // 数量增加1
  private plusAction() {
    let r: number = this.state.modelNum
    r = utils.cal(r, 1).add
    const maxNum = parseFloat(this.state.pageInfo.sku[0].stock)
    r = r > maxNum ? maxNum : r
    this.calcInfo(r)
    this.setState({ modelNum: r })
  }
  /**
   * [根据数量计算对应的阶梯价格]
   * @param  num [数量]
   */
  private calcInfo(num: number) {
    let skuPriceIndex = 0
    this.state.pageInfo.sku[0].price.forEach((v: any, k: number) => {
      if (num >= parseFloat(v.begin_num)) {
        skuPriceIndex = k
      }
    })
    this.setState({ skuPriceIndex })
  }
  // 返回上一页
  private backAction() {
    window.history.back()
  }
  // 获取商品数据
  private async getData() {
    const r = await request({
      data: {
        goodsId: this.state.id,
        shopDomain: (window as any).shopId,
      },
      method: "POST",
      url: `${config.PHPAPI}api/wshop/goods/goods-details`,
    })
    if (r.error_code === 0) {
      if (Number(r.data.lan_type) === 1) {
        window.location.href = "/m/"
        return
      }
      let modelNum = 1
      if (r.data.price_type === "1") {
        modelNum = r.data.sku[0].price[0].begin_num
      } else if (r.data.price_type === "2") {
        switch (r.data.point_num) {
          case "0":
            modelNum = 1
            break
          case "1":
            modelNum = 0.1
            break
          case "2":
            modelNum = 0.01
            break
          case "3":
            modelNum = 0.001
            break
        }
      }
      if (!r.data.goods_video_url && r.data.video_img_url) {
        r.data.img.unshift({
          goods_id: "",
          img_id: "",
          img_src: r.data.video_img_url,
          img_src_original: r.data.video_img_url,
        })
      }
      this.setState(
        {
          pageInfo: r.data,
          modelNum,
          soldout: Number(r.data.goods_status) !== 1,
        }
        // ,
        // () => {
        //   new DPlayer({
        //     container: document.getElementById("dplayer"),
        //     autoplay: true,
        //     video: {
        //       url: this.state.pageInfo.goods_video_url,
        //     },
        //   })
        // }
      )
      this.getStoreData(r.data.shop_id)
      setTimeout(() => {
        this.getUserInfo()
      }, 1000)
    }
  }
  // 获取店铺数据
  private async getStoreData(shopId: number) {
    const r = await request({
      data: {
        portType: 2,
        shopId,
      },
      method: "post",
      url: `${config.PHPAPI}api/wshop/shop/info`,
    })

    if (r.error_code === 0) {
      this.setState({
        storeInfo: r.data[shopId],
        member_type: r.data[shopId].member_type,
      })
    }
  }

  // 隐藏提示框
  private hideToastAction() {
    if (this.toastTimer) {
      clearTimeout(this.toastTimer)
    }
    this.toastTimer = setTimeout(() => {
      this.setState({ toastText: "", toastVisible: false })
    }, 2000)
  }

  /**
   * [显示提示框]
   * @param  text [提示文本]
   */
  private showToastAction(text: string) {
    this.setState({ toastText: text, toastVisible: true })
    this.hideToastAction()
  }

  /**
   * 校验数量
   * @return 校验结果
   */
  private checkNum(): boolean {
    // 最少必须为大于起批量
    const minNum = parseFloat(this.state.pageInfo.sku[0].price[0].begin_num)
    if (isNaN(this.state.modelNum) || this.state.modelNum < minNum) {
      this.showToastAction("数量必须为大于最低起批量")
      return false
    }
    if (this.state.modelNum > parseFloat(this.state.pageInfo.sku[0].stock)) {
      this.showToastAction("商品数量不能大于商品库存")
      return false
    }
    return true
  }
  // 添加进货单
  private async addCart() {
    if (this.state.soldout || !this.checkNum()) {
      return
    }
    const r = await request({
      data: {
        qty: this.state.modelNum,
        skuId: this.state.pageInfo.sku[0].sku_id,
      },
      method: "post",
      url: `${config.JAVAORDER}wiseshop/cart/add`,
    })
    if (r.code === 1) {
      this.showToastAction("添加成功")
    } else {
      this.showToastAction(r.msg)
    }
  }
  // 添加&取消关注
  private async collectAction() {
    const r = await request({
      data: {
        collType: 2,
        goodsId: this.state.pageInfo.goods_id,
        shopId: this.state.storeInfo.shop_id,
      },
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
      method: "post",
      url: `${config.PHPAPI}api/wshop/shop/collection`,
    })
    if (r.error_code === 0) {
      const pinfo = this.state.pageInfo
      pinfo.is_collect = pinfo.is_collect === 0 ? "1" : 0
      this.setState({ pageInfo: pinfo }, () => {
        this.toggleAttention(true)
      })
    }
  }
  private async buyNow() {
    if (this.state.soldout || !this.checkNum()) {
      return
    }
    const r = await request({
      url: `${config.CLASSAPI}safety/account/get`,
    })
    if (r.code === 1) {
      const r2 = await request({
        data: {
          qty: this.state.modelNum || "",
          skuId: this.state.pageInfo.sku[0].sku_id || "",
        },
        url: `${config.JAVAORDER}wiseshop/wap/buyer/order/clear/view`,
      })
      if (r2.code === 1) {
        window.location.href = `/m/order/?skuId=${this.state.pageInfo.sku[0].sku_id}&qty=${this.state.modelNum}`
      } else {
        this.showToastAction(r2.message.replace(/\<br\/\>/gi, ""))
      }
    }
  }
  // 索取样品
  private async goToDemo() {
    // const r = await utils.checkLogin();
    // if(r) {
    //   window.location.href = `/m/demo/?shopId=${this.state.storeInfo.shop_id}&goodsId=${this.state.pageInfo.goods_id}&companyId=${this.state.storeInfo.company_id}`;
    // }
    const that = this
    this.demoInstance.show(
      {
        goods_name: this.state.pageInfo.original_goods_name,
        goods_id: this.state.pageInfo.goods_id,
        shop_id: this.state.storeInfo.shop_id,
        company_id: this.state.storeInfo.company_id,
        data_source: 1,
      },
      {
        productName: this.state.pageInfo.original_goods_name,
        model: this.state.pageInfo.grade,
        manufacturer: this.state.pageInfo.manufacturer,
      },
      function () {
        const temp = that.state.pageInfo
        temp.sample = Number(temp.sample) + 1
        that.setState({
          pageInfo: temp,
        })
      }
    )
  }

  // 在线联系新信息
  private async getUserInfo() {
    // 检查是否已经登录
    const r = await request({
      url: `${config.CLASSAPI}safety/account/get`,
      noChecklogin: true,
    })
    if (r.code === 1) {
      this.getServiceMsg()
      setInterval(() => {
        this.getServiceMsg()
      }, 5000)
    }
  }

  private async getServiceMsg() {
    const r = await request({
      data: {
        goodsId: this.state.id,
        shopId: this.state.storeInfo.shop_id,
        status: 2,
        upRead: 2,
        page: 1,
      },
      method: "post",
      url: `${config.PHPAPI}api/shop/message-board/index`,
    })

    if (r.error_code === 0) {
      this.setState({
        showRedDot: false,
      })
      if (r.data.model.length > 0) {
        this.setState({
          showRedDot: true,
        })
      }
    }
  }

  // 在线联系
  private async goToConsult() {
    const r = await request({
      url: `${config.CLASSAPI}safety/account/get`,
    })
    if (r.code === 1) {
      window.location.href = `/m/consult/?shopId=${this.state.storeInfo.shop_id}&goodsId=${this.state.id}`
    }
  }

  // 询价
  private async askingPrice() {
    if (this.state.soldout) {
      return
    }
    const r = await utils.checkLogin()
    if (r) {
      window.location.href = `/m/inquiry/?id=${this.state.id}`
    }
  }

  /**
   * 显示询价提示
   * @param visible {boolean} 显示隐藏
   */
  private setAskingPriceTips(visible) {
    this.setState({
      askingPriceVisible: visible,
    })
  }

  // 获取SEO数据
  private async getSeoData() {
    const r = await request({
      data: {
        id: this.state.id,
        key: 1,
      },
      method: "get",
      url: `${config.PHPAPI}api/wshop/seo/seo-data`,
    })
    if (r.error_code === 0) {
      const d = document as any
      d.title = r.data.title
      d.querySelector("meta[name=keywords]").setAttribute(
        "content",
        r.data.keywords
      )
      d.querySelector("meta[name=description]").setAttribute(
        "content",
        r.data.description
      )
    }
  }

  /**
   * [toggleAttention 关注弹层]
   * @param  {[boolean]} visible [显示隐藏关注弹窗]
   */
  private toggleAttention(visible: boolean) {
    this.setState({
      attentShow: visible,
    })
  }

  private chooseConfirm() {
    this.setPanelVisibleAction(false)
    this.buyNow()
  }

  /**
   * [openVideo 显示隐藏视频播放]
   * @param visible: boolean
   * @param e any 事件
   */
  private openVideo(visible: boolean, e?: any) {
    this.setState(
      {
        videoVisible: visible,
      },
      () => {
        if (visible) {
          new DPlayer({
            container: document.getElementById("dplayer"),
            autoplay: true,
            video: {
              url: this.state.pageInfo.goods_video_url,
            },
          })
        }
      }
    )
  }
  private takePhoneHandle = async () => {
    window.location.href =
      "tel:" +
      (this.state.storeInfo.contact_tel ||
        this.state.storeInfo.contact_phone ||
        "15907538884")
    return
    const gid =
      window.location.pathname.indexOf("/offer/") > -1
        ? utils.GetQueryString("id")
        : ""
    const r = request({
      data: {
        shopDomain: (window as any).shopId,
        gid,
      },
      method: "post",
      url: config.PHPAPI + "api/wshop/default/bind",
    })

    r.then((res) => {
      if (res.error_code === 0) {
        window.location.href = "tel:" + res.data.tel
      } else {
        ;(window as any).alert(res.msg)
      }
    })
  }

  private showShopInfo() {
    if (
      this.state.storeInfo.product_quality === "0.00" &&
      this.state.storeInfo.technological_innovation === "0.00" &&
      this.state.storeInfo.cost_performance === "0.00" &&
      this.state.storeInfo.chain_services === "0.00" &&
      this.state.storeInfo.sales_service === "0.00"
    ) {
      return null
    }
    return (
      <div className="my-info">
        <div className="info-num">
          <span className="item">{this.state.storeInfo.product_quality}</span>
          <span className="item">
            {this.state.storeInfo.technological_innovation}
          </span>
          <span className="item">{this.state.storeInfo.cost_performance}</span>
          <span className="item">{this.state.storeInfo.chain_services}</span>
          <span className="item">{this.state.storeInfo.sales_service}</span>
        </div>
        <div className="info-box">
          <div className="info-item">商品</div>
          <div className="info-item">技术</div>
          <div className="info-item">响应</div>
          <div className="info-item info-item-xd">支持</div>
          <div className="info-item">供货</div>
        </div>
      </div>
    )
  }
}

ReactDOM.render(<Offer />, document.getElementById("root") as HTMLElement)



// WEBPACK FOOTER //
// ./src/containers/shop/offer/index.tsx